
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonFS from '~/components/common/buttons/ButtonFS.vue'
import ApplyPro from '~/components/common/freemium/ApplyPro.vue'

const referrers = ['credibility', 'applicant_count', 'application_status', 'automatically_reapply', 'payment']

const content = {
  [referrers[0]]: {
    title: 'Unlock credibility scores',
    text: ['Apply with confidence to scholarships rated', 'highly by our team.']
  },
  [referrers[1]]: {
    title: 'Unlock number of applicants',
    text: ['Boost your chances by applying to', 'scholarships with fewer applicants.']
  },
  [referrers[2]]: {
    title: 'Unlock application status',
    text: ['Track and monitor your scholarship', 'applications in real-time.']
  },
  [referrers[3]]: {
    title: 'Automatically reapply',
    text: ['Be automatically reapplied for scholarships with year-round winners.']
  },
  [referrers[4]]: {
    title: 'Unlock payment method',
    text: ['Organize your finances or strategize better for which scholarships to apply for.']
  }
}

type Referer = 'credibility' | 'applicant_count' | 'application_status' | 'automatically_reapply' | 'payment';

@Component({
  components: {
    ButtonFS,
    ApplyPro
  }
})
export default class ProLabelTooltip extends Vue {
  @Prop({ type: String }) referrer!: Referer
  @Prop({ type: Boolean, default: false }) shown: boolean

  get current() {
    return content[this.referrer]
  }
}
